import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim grounded in EAKC-MVP: docs/content/02-rag-pipeline-deep-dive.md,
// docs/content/diagrams/rag-pipeline-flow.md, src/lib/rag/*, migrations 009/033/034.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.5, caption: "Every RAG tutorial shows three steps. My production pipeline has eleven — and every stage exists because something broke." },
];

export const NAIVE: ScriptLine[] = [
  { scene: "naive", fromSec: 0.4, holdSec: 6, caption: "Naive RAG: embed the query, search a vector DB, hand the chunks to an LLM. Done." },
  { scene: "naive", fromSec: 6.6, holdSec: 6.5, caption: "It demos beautifully. Then you deploy it, and users say: it doesn't find anything useful." },
];

export const BROKE: ScriptLine[] = [
  { scene: "broke", fromSec: 0.4, holdSec: 5.5, caption: "Vague three-word queries returned garbage. Exact terms like 'pgvector' got buried." },
  { scene: "broke", fromSec: 6.2, holdSec: 6, caption: "The same query ran the full pipeline fifty times a day. No caching." },
  { scene: "broke", fromSec: 12.5, holdSec: 5, caption: "In a multi-tenant system, users could see chunks they should never have access to." },
];

export const PIPELINE: ScriptLine[] = [
  { scene: "pipeline", fromSec: 0.4, holdSec: 6.5, caption: "So the pipeline grew to eleven stages — three phases: understand the question, short-circuit, then retrieve and generate." },
  { scene: "pipeline", fromSec: 7.2, holdSec: 6.5, caption: "Cache miss: ~1.7s to first token. Cache hit runs stages 1–5 only — ~270ms, six times faster." },
  { scene: "pipeline", fromSec: 14, holdSec: 5, caption: "None of this is in the tutorials. All of it is in src/lib/rag." },
];

export const UNDERSTAND: ScriptLine[] = [
  { scene: "understand", fromSec: 0.4, holdSec: 6.5, caption: "Stages 1–4 understand the question: classify the intent, route the strategy, expand aliases, then rewrite." },
  { scene: "understand", fromSec: 7.2, holdSec: 6, caption: "Heuristic-first classification handles 80%+ of queries in under a millisecond, with zero API cost." },
];

export const SEARCH: ScriptLine[] = [
  { scene: "search", fromSec: 0.4, holdSec: 6, caption: "Stage 7 is the secret sauce: hybrid search. Vector for meaning, BM25 for exact words, fused 0.7 / 0.3." },
  { scene: "search", fromSec: 6.6, holdSec: 7, caption: "Migration 009: two CTEs in one Postgres function — cosine distance and ts_rank_cd — over-fetched 3×." },
  { scene: "search", fromSec: 14, holdSec: 7.5, caption: "And here's the scar: plainto_tsquery uses AND. A five-word question matched no chunk. BM25 returned 0 for weeks." },
];

export const GUARD: ScriptLine[] = [
  { scene: "guard", fromSec: 0.4, holdSec: 6, caption: "Stage 8 filters by access control — fail-closed. Unknown policy means deny, never grant." },
  { scene: "guard", fromSec: 6.6, holdSec: 6.5, caption: "Stage 9 reranks five chunks per LLM batch — catching the false positives embeddings let through." },
];

export const PAYOFF: ScriptLine[] = [
  { scene: "payoff", fromSec: 0.4, holdSec: 6, caption: "Migration 033 swapped AND for OR-semantics. Migration 034 split camelCase in the index." },
  { scene: "payoff", fromSec: 6.6, holdSec: 6.5, caption: "Code-query retrieval went from ~75% to a peak of 90%. Doc queries already at ~90%, unchanged." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "Eleven stages isn't over-engineering. It's eleven production failures, each turned into a stage." },
  { scene: "outro", fromSec: 5.6, holdSec: 4.5, caption: "Next: the full postmortem — every way naive RAG fails in production, and the fixes." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
